import {
  DRAWER_TYPE,
  SWITCH_LANGUAGE,
  SWITCH_LANGUAGE_SUCCESS,
  TOGGLE_COLLAPSED_NAV,
  WINDOW_WIDTH,
} from '../constants/ActionTypes';

export function toggleCollapsedNav(isNavCollapsed) {
  return { type: TOGGLE_COLLAPSED_NAV, isNavCollapsed };
}

// The DRAWER_TYPE reducer case, the three `app-container` modifier classes and all
// the mini-drawer SCSS have existed since the template was adopted, but nothing has
// ever dispatched the action — so `drawerType` never moved off the reducer's
// `[FIXED_DRAWER]` default and the 80px icon-strip mode has been dead code.
// Manage Routes V2 needs it: at 1440 the 280px nav leaves too little for a
// three-column editor, and mini mode hands back 200px.
export function setDrawerType(drawerType) {
  return { type: DRAWER_TYPE, drawerType };
}

export function updateWindowWidth(width) {
  return { type: WINDOW_WIDTH, width };
}

export function switchLanguage(locale) {
  return {
    type: SWITCH_LANGUAGE,
    payload: locale,
  };
}

export function switchLanguageSuccess(locale) {
  return {
    type: SWITCH_LANGUAGE_SUCCESS,
    payload: locale,
  };
}
